import React from "react";
import classes from "./AdditionalLodging.module.css";
import headerClasses from "../Home/Home.module.css";
import "react-slideshow-image/dist/styles.css";
import { Slide } from "react-slideshow-image";
import PublicCalendar, {
  ROBINS_ROOST_CALENDAR_ID,
} from "../Contact/PublicCalendar";

import {
  RRAerial,
  RRAerial2,
  RRAerial3,
  RRFront,
  RRPorch,
  RRPorch2,
  RRexterior,
  RRbedroom1,
  RRbedroom2,
  RRbedroom3,
  RRbedroom4,
  RRinterior1,
  RRinterior2,
  RRinterior3,
  RRinterior4,
  RRinterior5,
  RRinterior6,
} from "../../Assets";

const AdditionalLodging = () => {
  const exteriorImages = [
    RRAerial,
    RRAerial2,
    RRAerial3,
    RRFront,
    RRPorch,
    RRPorch2,
    RRexterior,
  ];

  const interiorImages = [
    RRbedroom1,
    RRbedroom2,
    RRbedroom3,
    RRbedroom4,
    RRinterior1,
    RRinterior2,
    RRinterior3,
    RRinterior4,
    RRinterior5,
    RRinterior6,
  ];

  const slideProps = {
    transitionDuration: 300,
    autoplay: false,
  };

  return (
    <div>
      <div className={classes.headerBackdrop}>
        <div className={headerClasses.header}>
          <h1>Additional Lodging</h1>
        </div>
      </div>

      <div className={classes.textContainer}>
        <h2>Welcome to Robin’s Roost</h2>
        <p className={classes.contactText}>
          Nestled in the heart of Snohomish valley, Robin’s Roost is a serene
          1,860 sq. ft. retreat located at{" "}
          <a
            href="https://www.google.com/maps/search/?api=1&query=10121 109th St SE Snohomish WA"
            target="_blank"
            rel="noopener noreferrer"
          >
            10121 109th St SE, Snohomish, WA, 98296
          </a>
          , perfectly suited for your wedding week. With 4 bedrooms plus a loft
          that comfortably sleeps 14 guests, there is room for the whole family.
          Including 3 bathrooms, ample dining area, a fully stocked kitchen, all
          the amenities, and 4 acres of lush, private land. It offers a peaceful
          sanctuary for you and your loved ones to prepare for the big day.
          <br />
          <br />
          $590 per night for Fridays and Saturdays; $395 per night for all other
          days.
        </p>
      </div>

      <div className={classes.slideshow}>
        <Slide {...slideProps}>
          {interiorImages.map((image, index) => (
            <div key={index} className={classes.imgWrapper}>
              <img src={image} alt={`Interior view ${index + 1}`} />
            </div>
          ))}
        </Slide>
      </div>

      <div className={classes.slideshow}>
        <Slide {...slideProps}>
          {exteriorImages.map((image, index) => (
            <div key={index} className={classes.imgWrapper}>
              <img src={image} alt={`Exterior view ${index + 1}`} />
            </div>
          ))}
        </Slide>
      </div>

      <div className={classes.textContainer}>
        <h2>Availability</h2>
        <p className={classes.contactText}>
          If you're interested in booking Robin’s Roost, please refer to the
          calendar below to verify that your dates are available. You can
          contact us by phone at 206-399-0681 or by email at{" "}
          <a href="mailto:booking@prettybirdwedding.com?subject=Robin%27s%20Roost%20Rental%20Inquiry&body=To%20request%20a%20booking%20please%20fill%20out%20the%20following%20information.%20Minimum%202%20night%20stay%20for%20each%20reservation%3A%20%0D%0A%0D%0AName%3A%20%0D%0AContact%20Email%3A%20%0D%0APhone%20number%3A%20%0D%0ADates%20desired%3A%20%0D%0ANumber%20of%20Guests%3A%20%0D%0AAny%20Additional%20Items%20or%20Questions%3A%20">
            booking@prettybirdwedding.com
          </a>
          . Please include your full name, email, phone number, dates you're
          looking to book, and number of guests. We require a minimum 2 night
          stay for each reservation.
        </p>
      </div>

      <PublicCalendar
        calendarId={ROBINS_ROOST_CALENDAR_ID}
        showWinterClosure={false}
      />
    </div>
  );
};

export default AdditionalLodging;
